import React, { useState } from 'react';
import { cameraApi } from '../../services/api';
import { useAppStore } from '../../store/appStore';

const PRESET_COLORS = ['#00d4ff','#00ff88','#ffaa00','#ff3344','#8855ff','#ff6b35','#00ccff','#66ff66'];

export default function AddGroupModal({ onClose, onSaved }) {
  const { addToast, setGroups, groups } = useAppStore();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [color, setColor] = useState('#00d4ff');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!name) return;
    setLoading(true);
    try {
      const res = await cameraApi.createGroup({ name, description, color });
      setGroups([...groups, res.data]);
      addToast({ type: 'success', message: `Group "${name}" created` });
      onSaved();
    } catch {
      addToast({ type: 'error', message: 'Failed to create group' });
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal" style={{ maxWidth: '420px' }}>
        <div className="modal-header">
          <h2>Create Group</h2>
          <button className="btn btn-ghost btn-sm btn-icon" onClick={onClose}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div style={{ marginBottom: '14px' }}>
              <label className="label">Group Name *</label>
              <input className="input-field" placeholder="Main Building" value={name} onChange={e => setName(e.target.value)} autoFocus />
            </div>
            <div style={{ marginBottom: '14px' }}>
              <label className="label">Description</label>
              <input className="input-field" placeholder="Cameras in main building" value={description} onChange={e => setDescription(e.target.value)} />
            </div>
            <div>
              <label className="label">Color</label>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '6px' }}>
                {PRESET_COLORS.map(c => (
                  <button
                    key={c}
                    type="button"
                    onClick={() => setColor(c)}
                    style={{
                      width: '28px', height: '28px',
                      borderRadius: '50%',
                      background: c,
                      border: color === c ? '2px solid #fff' : '2px solid transparent',
                      cursor: 'pointer',
                      boxShadow: color === c ? `0 0 8px ${c}` : 'none',
                      transition: 'all 0.15s',
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-ghost" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={loading || !name}>
              {loading ? 'Creating...' : 'Create Group'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
